import { Controller } from '@hotwired/stimulus'

export default class OnboardingSignupController extends Controller {
  static values = {
    isEmail: Boolean
  }

  connect() {
    // this.userInterest()
    this.languageCount()
    if ($(this.element).hasClass('sign-up-form')) {
      this.handleDisabledButton();

      setTimeout(() => {
        this.toggleContactField(this.isEmailValue)
      }, 0);
    }
  }

  handleDisabledButton() {
    this.submitButton = this.element.querySelector(".submit_button")
  }

  toggleSubmitButton() {
    const requiredFields = [...this.element.querySelectorAll("[required]")]

    const allFilled = requiredFields.every(field => {
      if (field.closest(".d-none")) return true

      return field.value.trim() !== ""
    })

    this.submitButton.disabled = !allFilled
  }

  toggleContactField(isEmail) {
    $('#email,.phoneLink').toggleClass('d-none', !isEmail)
    $('#phone,.emailLink').toggleClass('d-none', isEmail)

    $('label.error, .error, .error-msg').not('select, input').html('')
    $('select.error').removeClass('error')

    $('.email-field').prop('disabled', !isEmail)
    $('.phone-no, .country_code').prop('disabled', isEmail)
    if (isEmail) {
      const val = $('.email-field').val()
      $('.email-field').val('')
      $('.email-field').val(val)
    }
    this.toggleSubmitButton()
    setTimeout(() => {
      window.skipBlurValidation = false
    }, 0)
  }

  startSwitch() {
    window.skipBlurValidation = true
  }

  get_email_field() {
    this.toggleContactField(true)
  }

  get_phone_field() {
    this.toggleContactField(false)
  }

  check_user(e) {
    e.preventDefault()
    const name = String($('#user-name').val() || '').trim()
    $('#sign-in-link').attr('href', '#')
    if (this.timeout) clearTimeout(this.timeout)
    if (!name) {
      $('.name_error')
        .removeClass('d-none')
        .addClass('error')
        .html('Please enter email, username or phone number')
      return
    }
    this.timeout = setTimeout(() => {
      fetch('/check_user', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || '',
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
          user_name: name
        })
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.user) {
            $('.name_error').addClass('d-none').removeClass('error').html('')
            $('.name-submit').removeClass('disabled')
            const src = `/password/?user_name=${encodeURIComponent(name)}`
            const modalFrame = document.getElementById('modal_content')

            if (modalFrame) {
              modalFrame.src = src
            } else {
              Turbo.visit(src, { action: 'advance' })
            }
          } else {
            $('.name_error')
              .removeClass('d-none')
              .addClass('error')
              .html("Sorry, we couldn't find your account.")
          }
        })
    }, 1000)
  }

  // userInterest() {
  //   let total = document.querySelectorAll('.checkbox-pink.interest')
  //   const checked = Array.from(total).filter((cb) => cb.checked).length
  //   let errorBox = document.getElementById('content_error')
  //   let submitButton = document.querySelector('.interest-button')
  //   if (!submitButton) {
  //     return
  //   }
  //   if (checked >= 3) {
  //     errorBox.innerHTML = ''
  //     submitButton.disabled = false
  //   } else if (checked > 0 && checked < 3) {
  //     errorBox.innerHTML = `<!--<p class="text-danger fs-18">Please select at least 3 interest.</p>-->`
  //     submitButton.disabled = true
  //   } else if (checked === 0) {
  //     errorBox.innerHTML = ''
  //     submitButton.disabled = true
  //   }
  // }

  userFollow(e) {
    $(this.element)
      .closest('.modal-body')
      .next('div')
      .find('.follow-button')
      .removeClass('disabled')
  }

  disableButton(e) {
    $('#content_error').find('p').html(' ')
    $(e.currentTarget).closest('form').find('button').prop('disabled', false)
  }

  languageCount(e) {
    if (!$(this.element).hasClass('language-form')) return;

    const checkboxes = document.querySelectorAll('.checkbox-pink.language')
    const checked = Array.from(checkboxes).filter((cb) => cb.checked).length
    let errorBox = document.getElementById('content_error')
    let submitButton = document.querySelector('.language-btn')
    if (!submitButton) {
      return
    }

    if (checked > 5) {
      e.target.checked = false
      errorBox.innerHTML = `<p class="text-danger fs-18">You can select maximum 5 languages</p>`
    } else if (checked === 0) {
      errorBox.innerHTML = ''
      submitButton.disabled = true
    } else {
      errorBox.innerHTML = ''
    }
  }

  removeError(e) {
    e.stopPropagation()
    $('.name_error').html('')
  }

  normalizeSignInIdentifier (e) {
    const input = e.currentTarget
    const valueWithoutSpaces = input.value.replace(/\s/g, '')

    if (input.value !== valueWithoutSpaces) input.value = valueWithoutSpaces
    this.removeError(e)
  }
}
